import React from 'react';

const ErrorNeedsSupport = ({ error }) => (
	<>
		<p className="px-3 px-md-4 mb-3 color-red">
			{error}
		</p>
		<p className="px-3 px-md-4 mb-3">
		If this continues, please
		contact Buddy support by email at
			{' '}
			<a
				target="_blank"
				rel="noopener noreferrer"
				className="inline-link"
				href="mailto:support@buddy.insure"
			>
			support@buddy.insure
			</a>
			{' '}
				to get it resolved.
		</p>
	</>
);

export default ErrorNeedsSupport;
